import React, { Component } from "react"
import config from "react-global-configuration"
import { getCssLegend, getContentEnrichedProduct } from "../../helpers/bookingHelper"

class ParkingListElement extends Component {
  handleDetailsClick = () => {
    this.props.setParkingDetailModalState({
      parkingDetailsModalGaList: this.props.gaList,
      parkingDetailsModalGaListIndex: this.props.gaListIndex,
      isParkingDetailsModalActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(this.props.item, this.props.content),
      isAmendment: this.props.isAmendment,
    })
  }

  handleSpecialProductClick = () => {
    this.props.setParkingDetailModalState({
      parkingDetailsModalGaList: this.props.gaList,
      parkingDetailsModalGaListIndex: this.props.gaListIndex,
      isParkingSpecialProductActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(this.props.item, this.props.content),
    })
  }

  handleMemberProductClick = () => {
    this.props.setParkingDetailModalState({
      parkingDetailsModalGaList: this.props.gaList,
      parkingDetailsModalGaListIndex: this.props.gaListIndex,
      isParkingMemberProductActive: true,
      isAmendment: this.props.isAmendment,
      parkingDetailsModalItem: getContentEnrichedProduct(this.props.item, this.props.content, this.props.isAmendment),
    })
  }

  handleBuyClickFunction = (item, isAmendment = false) => {
    const { product, result } = item
    const changeFromLoggedIn = this.props.changeFromBooking?.booking?.membershipNumber ? true : false
    const isSpecialProduct = product && product.dynamicFields && product.dynamicFields.isSpecialProduct
    const showMemberprice = result?.showMemberPrice

    const { userAccountDetails, changeFromBooking } = this.props

    const isLoggedIn = !!userAccountDetails

    isSpecialProduct
      ? this.handleSpecialProductClick()
      : showMemberprice && !isLoggedIn && !changeFromLoggedIn
        ? this.handleMemberProductClick()
        : this.props.handleReservation(product.id, item, null, isAmendment)
  }

  renderTypeOfParking = (textKeys, carPark) => {
    switch (carPark.transferFrequency) {
      case "1":
        return (
          <p>
            <svg className="svg-icon svg-icon--sun">
              <use xlinkHref="/dist/svg/symbols.svg#svg-sun"></use>
            </svg>
            {textKeys.outdoorParking || "Udendørs parkeringsanlæg"}
          </p>
        )
      case "2":
        return (
          <p>
            <svg className="svg-icon svg-icon--sun">
              <use xlinkHref="/dist/svg/symbols.svg#svg-carindoors"></use>
            </svg>
            {textKeys.indoorParking || "Indendørs parkeringsanlæg"}
          </p>
        )
      case "3":
        return (
          <p>
            <svg className="svg-icon svg-icon--sun">
              <use xlinkHref="/dist/svg/symbols.svg#svg-sun"></use>
            </svg>
            {textKeys.in_outdoorParking || "Inden- og udendørsparkering"}
          </p>
        )
      default:
        return <div dangerouslySetInnerHTML={{ __html: `<!-- ${JSON.stringify(carPark)} -->` }} />
    }
  }

  render() {
    const { globals } = this.props
    const { userAccountDetails, changeFromBooking, isAmendment } = this.props

    const { product, carPark, result } = this.props.item
    const textKeys = config.get("textKeys.parkingList.listElement") || {}
    const wpyfSettings = config.get("textKeys.weParkYouFlySettings") || {}

    //membercheckup.
    const isLoggedIn = !!userAccountDetails
    const changeFromLoggedIn = !!this.props.changeFromBooking?.booking?.membershipNumber
    const hasLoggedInInfo = !!(isLoggedIn || changeFromLoggedIn)

    //price setting variables
    const isSpecialProduct = product && product.dynamicFields && product.dynamicFields.isSpecialProduct
    const showMemberprice = result?.showMemberPrice
    const showPriceDifference = this.props.isAmendment

    //price value variables
    const effectivePrice = showMemberprice ? result.memberPrice : result.totalPrice
    let changeFromBookingPrice = 0
    if (changeFromBooking) {
      changeFromBookingPrice = changeFromBooking.booking.items.parkings[0].amount
    }
    const pricePrefix = changeFromBooking ? (result.totalPrice - changeFromBookingPrice > 0 ? "+" : "") : null
    const differencePrice = showPriceDifference ? effectivePrice - changeFromBookingPrice : effectivePrice

    //carpark variables
    const lotCode = carPark.name
    const legend = getCssLegend(carPark.name, product.name)

    //product
    let promotionBanner =
      result.originalPrice > result.totalPrice && globals.promotionName
        ? globals.promotionName
        : result && result.thirdPartyPromoLabelText
          ? result.thirdPartyPromoLabelText
          : product.dynamicFields && product.dynamicFields.calloutBanner
            ? product.dynamicFields.calloutBanner
            : undefined

    // use affiliateBanner if an affiliateCode is active
    const affiliateCheck = this.props.affiliateCode && result.affiliateResult && product.dynamicFields.affiliateBanner
    if (affiliateCheck) {
      promotionBanner = product.dynamicFields.affiliateBanner
    }

    let ribbonStyle = {}
    if (result?.thirdPartyPromoLabelColorCode && !affiliateCheck && !(result.originalPrice > result.totalPrice && globals.promotionName)) {
      ribbonStyle = { backgroundColor: result.thirdPartyPromoLabelColorCode }
    }

    const isNewBooking = !this.props.isAmendment

    if (isNewBooking) {
      return (
        <React.Fragment>
          <div className="parking-product-table__list__row">
            <div className="parking-product-table__list__row__body w--wider">
              <div className="parking-product-table__list__col parking-product-table__list__col--title">
                <div className="parking-legend parking-legend--list">
                  <span className={`parking-legend__item parking-legend__item--${legend}`}>{lotCode}</span>
                </div>
                <h5>{product.name}</h5>
                {/* <button className="link js--open-modal"
                onClick={this.handleDetailsClick}
              ><small>{textKeys.readMore || "Læs mere"}</small></button> */}
              </div>
              <div className="parking-product-table__list__col parking-product-table__list__col--usp">
                <div className="parking-product-table__list__col--usp-distance">
                  {carPark.transferMethod === "Bus" ? (
                    <p>
                      <svg className="svg-icon svg-icon--bus">
                        <use xlinkHref="/dist/svg/symbols.svg#svg-bus"></use>
                      </svg>
                      {carPark.transferTime} {textKeys.busTime || "min. i bus til terminalen"}
                    </p>
                  ) : (
                    <p>
                      <svg className="svg-icon svg-icon--bus">
                        <use xlinkHref="/dist/svg/symbols.svg#svg-passenger"></use>
                      </svg>
                      {carPark.transferTime} {textKeys.walkTime || "min. gang til terminalen"}
                    </p>
                  )}
                </div>
                <div className=" parking-product-table__list__col--usp-location">
                  {product.dynamicFields && product.dynamicFields.productValet ? (
                    <p>
                      <svg className="svg-icon svg-icon--sun">
                        <use xlinkHref="/dist/svg/symbols.svg#svg-keypickup"></use>
                      </svg>
                      {textKeys.indoorDeliverOutdoorParking || "Indendørs aflevering - udendørs parkering"}
                    </p>
                  ) : (
                    this.renderTypeOfParking(textKeys, carPark)
                  )}
                </div>
                <div className="parking-product-table__read-more d-none--lg">
                  <button className="link js--open-modal" onClick={this.handleDetailsClick}>
                    <small>{textKeys.readMore || "Læs mere"}</small>
                  </button>
                </div>
              </div>
              <div className="parking-product-table__list__col parking-product-table__list__col--banner d-none d-flex--lg">
                {promotionBanner ? (
                  <span className="angled-ribbon angled-ribbon--dynamic">
                    <span className="angled-ribbon__inner" style={ribbonStyle}>
                      <span className="text">{promotionBanner}</span>
                    </span>
                  </span>
                ) : (
                  ""
                )}
              </div>

              <div className="parking-product-table__list__col parking-product-table__list__col--price">
                <div className="parking-product-table__list__col parking-product-table__list__col--banner d-none--lg">
                  {promotionBanner ? (
                    <span className="angled-ribbon angled-ribbon--dynamic">
                      <span className="angled-ribbon__inner" style={ribbonStyle}>
                        <span className="text">{promotionBanner}</span>
                      </span>
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                <div className="parking-product-table__price-column">
                  <div className="parking-product-table__prices-and-cta">
                    <div className="parking-product-table__price-details">
                      {showMemberprice ? <p className="headline-xxxs">{textKeys.memberPrice || "Medlemspris"}</p> : ""}
                      <div className="parking-product-table__price-and-status">
                        {Math.abs(product.maxCapacity - product.currentlyBooked) <= 25 && !product.isSoldOut ? (
                          <p className="t--highlight-shop parking-product-table__status">{textKeys.fewSpots || "Få pladser online"}</p>
                        ) : (
                          ""
                        )}
                        <h5 className={`parking-product-table__price${product.isSoldOut ? " parking-product-table__price--soldout" : ""}`}>
                          {" "}
                          {this.props.priceFormatter(effectivePrice)}
                        </h5>
                      </div>
                      {showMemberprice ? (
                        <p className={hasLoggedInInfo ? "price-line-through" : "parking-product-table__sub"}>
                          {textKeys.nonMemberPrice || "Pris uden CPH Profil"}: <span>{this.props.priceFormatter(result.totalPrice)}</span>
                        </p>
                      ) : (
                        ""
                      )}
                      {result?.showPayOnFootPrice ? (
                        <p className="price-line-through parking-product-table__sub">
                          {textKeys.normalOnlinePrice || "Normal onlinepris: "}
                          <span>{this.props.priceFormatter(result.payOnFootPrice)}</span>
                        </p>
                      ) : (
                        ""
                      )}
                      {result?.showOriginalPrice ? (
                        <p className="price-line-through parking-product-table__sub">
                          {textKeys.previousPrice || "Førpris: "}
                          <span>{this.props.priceFormatter(result.originalPrice)}</span>
                        </p>
                      ) : (
                        ""
                      )}
                      {result?.showDriveInPrice ? (
                        <p className="parking-product-table__sub">
                          {textKeys.drivePrice || "Drive in-pris: "}
                          <span>{this.props.priceFormatter(result.barrierTariff)}</span>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="parking-product-table__cta">
                      <div className="parking-product-table__list__col parking-product-table__list__col--cta">
                        {!product.isSoldOut ? (
                          <button className="button button--small button--general" onClick={() => this.handleBuyClickFunction(this.props.item)}>
                            <span className="text">{textKeys.reserve || "Reservér"}</span>
                          </button>
                        ) : product.isSoldOut && product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed ? (
                          <button className="button button--small button--general is-disabled">
                            <span className="text">{wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"}</span>
                          </button>
                        ) : (
                          <button className="button button--small button--general is-disabled">
                            <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
                          </button>
                        )}
                        <div className="parking-product-table__read-more d-none d-flex--lg">
                          <button className="link js--open-modal" onClick={this.handleDetailsClick}>
                            <small>{textKeys.readMore || "Læs mere"}</small>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    }

    // in amendment flow
    return (
      <React.Fragment>
        <div
          className={`parking-product-table__list__row ${
            this.props.item.carPark.id === this.props.changeFromBooking.booking.carParkId ? "d-none" : ""
          }`}
        >
          <div className="parking-product-table__list__row__body w--wider">
            <div className="parking-product-table__list__col parking-product-table__list__col--title">
              <div className="parking-legend parking-legend--list">
                <span className={`parking-legend__item parking-legend__item--${legend}`}>{lotCode}</span>
              </div>
              <h5>{product.name}</h5>
              {/* <button className="link js--open-modal"
                onClick={this.handleDetailsClick}
              ><small>{textKeys.readMore || "Læs mere"}</small></button> */}
            </div>
            <div className="parking-product-table__list__col parking-product-table__list__col--usp">
              <div className="parking-product-table__list__col--usp-distance">
                {carPark.transferMethod === "Bus" ? (
                  <p>
                    <svg className="svg-icon svg-icon--bus">
                      <use xlinkHref="/dist/svg/symbols.svg#svg-bus"></use>
                    </svg>
                    {carPark.transferTime} {textKeys.busTime || "min. i bus til terminalen"}
                  </p>
                ) : (
                  <p>
                    <svg className="svg-icon svg-icon--bus">
                      <use xlinkHref="/dist/svg/symbols.svg#svg-passenger"></use>
                    </svg>
                    {carPark.transferTime} {textKeys.walkTime || "min. gang til terminalen"}
                  </p>
                )}
              </div>
              <div className=" parking-product-table__list__col--usp-location">
                {product.dynamicFields && product.dynamicFields.productValet ? (
                  <p>
                    <svg className="svg-icon svg-icon--sun">
                      <use xlinkHref="/dist/svg/symbols.svg#svg-keypickup"></use>
                    </svg>
                    {textKeys.indoorDeliverOutdoorParking || "Indendørs aflevering - udendørs parkering"}
                  </p>
                ) : (
                  this.renderTypeOfParking(textKeys, carPark)
                )}
              </div>
              <div className="parking-product-table__read-more d-none--lg">
                <button className="link js--open-modal" onClick={this.handleDetailsClick}>
                  <small>{textKeys.readMore || "Læs mere"}</small>
                </button>
              </div>
            </div>
            <div className="parking-product-table__list__col parking-product-table__list__col--banner d-none d-flex--lg">
              {promotionBanner && !hasLoggedInInfo ? (
                <span className="angled-ribbon angled-ribbon--dynamic">
                  <span className="angled-ribbon__inner" style={ribbonStyle}>
                    <span className="text">{promotionBanner}</span>
                  </span>
                </span>
              ) : (
                ""
              )}
            </div>

            <div className="parking-product-table__list__col parking-product-table__list__col--price">
              <div className="parking-product-table__list__col parking-product-table__list__col--banner d-none--lg">
                {promotionBanner && !hasLoggedInInfo ? (
                  <span className="angled-ribbon angled-ribbon--dynamic">
                    <span className="angled-ribbon__inner" style={ribbonStyle}>
                      <span className="text">{promotionBanner}</span>
                    </span>
                  </span>
                ) : (
                  ""
                )}
              </div>

              <div className="parking-product-table__price-column">
                <div className="parking-product-table__prices-and-cta">
                  <div className="parking-product-table__price-details">
                    {showMemberprice ? <p className="headline-xxxs">{textKeys.memberPrice || "Medlemspris"}</p> : ""}
                    {/* <p className="headline-xxxs">{differencePrice < 0 ? (textKeys.amendSave || 'Refundering') : (textKeys.amendPayExtra || 'Ekstrabetaling')}</p> */}
                    <div className="parking-product-table__price-and-status">
                      <h5 className={`parking-product-table__price${product.isSoldOut ? " parking-product-table__price--soldout" : ""}`}>
                        {differencePrice > 0 && this.props.isAmendment ? "+" : ""}
                        {this.props.priceFormatter(showPriceDifference ? differencePrice : effectivePrice)}
                      </h5>
                    </div>
                    {showMemberprice && !hasLoggedInInfo ? (
                      <p className={`${hasLoggedInInfo ? "price-line-through" : ""} parking-product-table__sub`}>
                        {textKeys.nonMemberPrice || "Pris uden CPH profil"}:{" "}
                        <span>
                          {isAmendment ? pricePrefix : ""}
                          {isAmendment
                            ? this.props.priceFormatter(result.totalPrice - changeFromBookingPrice)
                            : this.props.priceFormatter(result.totalPrice)}
                        </span>
                      </p>
                    ) : (
                      ""
                    )}
                    {result.showPayOnFootPrice && !hasLoggedInInfo ? (
                      <p className="price-line-through parking-product-table__sub">
                        {textKeys.normalOnlinePrice || "Normal onlinepris: "}
                        <span>{this.props.priceFormatter(result.payOnFootPrice)}</span>
                      </p>
                    ) : (
                      ""
                    )}
                    {result.showOriginalPrice && !hasLoggedInInfo ? (
                      <p className="price-line-through parking-product-table__sub">
                        {textKeys.previousPrice || "Førpris: "}
                        <span>{this.props.priceFormatter(result.originalPrice)}</span>
                      </p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="parking-product-table__cta">
                    <div className="parking-product-table__list__col parking-product-table__list__col--cta">
                      {!product.isSoldOut ? (
                        <button
                          className="button button--small button--general"
                          onClick={() => this.handleBuyClickFunction(this.props.item, this.props.isAmendment)}
                        >
                          <span className="text">{textKeys.reserve || "Reservér"}</span>
                        </button>
                      ) : product.isSoldOut && product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed ? (
                        <button className="button button--small button--general is-disabled">
                          <span className="text">{wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"}</span>
                        </button>
                      ) : (
                        <button className="button button--small button--general is-disabled">
                          <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
                        </button>
                      )}
                      <div className="parking-product-table__read-more d-none d-flex--lg">
                        <button className="link js--open-modal" onClick={this.handleDetailsClick}>
                          <small>{textKeys.readMore || "Læs mere"}</small>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default ParkingListElement
